import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges,
  OnInit, Output, ChangeDetectorRef, OnDestroy} from '@angular/core';
import {BaseComponent} from '../../components/general/base/base.component';
import {Point} from 'geojson';
import {MapElement} from '../../shared/map/map-element.model';
import {LinkingCrudService} from '../../linking/linking.service';
import {AuthService} from '../../auth/auth.service';
import { isFollowingAvailableForFeature } from '../../custom/vrgroup/follow-train/follow-utils';
import { Layer } from '../../shared/map/layer/layer.model';

interface VisibleButtonConfig {
  info: boolean;
  focus: boolean;
  flag: boolean;
  follow: boolean
  cargoManifest: boolean
}

@Component({
  selector: 'qm-element-actions',
  templateUrl: './element-actions.component.html',
  styleUrls: ['./element-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ElementActionsComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  public selectedFeature: MapElement<Point>;
  @Input()
  public selectedLayer: Layer;
  @Input()
  public qmStyle: { [key: string]: string; };
  @Input()
  public visibleButtons: VisibleButtonConfig = {
      info: true,
      focus: true,
      flag: true,
      follow: true,
      cargoManifest: false,
  };
  @Output()
  public detailsOpened: EventEmitter<void> = new EventEmitter();

  public vivoId: string = null;
  /**
   * Username
   */
  public userName: string;
  private vivoType: string = 'Asset';

  public tenant: number;
  public showVrInfo: boolean = true;

  private closed: boolean = false;

  /**
   * @param {MapService} mapService
   * @param {VivoService} vivoService
   */
  constructor(private linkingCrudService: LinkingCrudService, private auth: AuthService, private cdr: ChangeDetectorRef) {
    super();
    this.name = 'ElementActionsComponent';
    this.userName = this.auth.getSubject();
    this.tenant = this.auth.getTenant();
  }

  ngOnInit() {
    this.updateVivoMapping();
  }

  ngOnChanges() {
    this.updateVivoMapping();
    const isSelectedFeatureOnMap = this.selectedFeature?.geometry?.coordinates
      && this.selectedFeature.geometry.coordinates[0] !== 0;
    this.visibleButtons.focus = isSelectedFeatureOnMap;
    this.visibleButtons.follow = isFollowingAvailableForFeature(this.selectedFeature) && isSelectedFeatureOnMap;
  }

  ngOnDestroy() {
    this.closed = true;
  }

  onDetailsOpened() {
    this.detailsOpened.emit();
  }

  public setVrInfoVisibility(show: boolean) {
    this.showVrInfo = show;
    if (!this.closed) {
      this.cdr.detectChanges();
    }
  }

  private async updateVivoMapping(): Promise<void> {
    if (this.selectedFeature) {
      // Use feature's id in cases that selectedLayer is not defined
      const regoId = this.selectedLayer !== undefined
        ? this.selectedFeature.properties[this.selectedLayer.metadata.uniqueBy]
        : this.selectedFeature.id;
      const linking = await this.linkingCrudService.getSourceIdForRegoId(regoId, 'vivo');
      if (linking) {
        this.vivoId = linking.sourceId;
        this.vivoType = linking.sourceLinkType;
        this.cdr.detectChanges(); //// to get VIVO link visible ??
      }
    }
  }

  /**
   * Return link to VIVO for current map object
   * @returns {string}
   */
  public getVivoLink(): string {
    if (this.vivoType === 'Organization') {
      return 'https://miprovivo.trackinno.com/organizationNodes/' + this.vivoId + '/assets';
    } else {
      return 'https://miprovivo.trackinno.com/assets/' + this.vivoId;
    }
  }
}
